// This is a custom legend for KFF Datacenter

import d3 from 'd3';
import rows from './rows';
import * as util from './util';
import { legendOptions as defaultOptions } from './../../config/legend';

/**
 * Function which builds the d3 legend
 * @param  {string} selector  dom element which should contain the svg
 * @param  {array} data       array of data objects to setup legend
 * @param  {object} options   sepecific option types
 * @return {null}
 *
 */
export default function(selector, data, inputOptions = {}) {
  // Setup default options and information needed for the build
  const options = Object.assign({}, defaultOptions, inputOptions);

  options.availableWidth = options.width -
    options.margin.left -
    options.margin.right;

  options.columnWidth = Math.floor(options.availableWidth / options.maxSplit);

  // Initialize the legend
  init(
    selector,
    util.buildData(data, options),
    options
  );
}

function init(selector, data, options) {
  if (!options.isMap) {
    d3.select(selector)
      .select(options.wrapper)
      .remove();
  } else {
    d3.select(selector)
      .select('g.datamaps-legend')
      .remove();
  }

  const container = d3.select(selector)
    .append(options.wrapper)
    .classed('datamaps-legend', () => options.isMap)
    .attr('width', options.width)
    .attr(
      'transform',
      `translate(${options.left}, ${options.top})`
    );

  const legend = container.selectAll('g.legend')
    .data(data);

  const legendEnter = legend.enter()
    .append('g')
    .classed('legend', true)
    .attr(
      'transform',
      `translate(${options.margin.right}, ${options.margin.top})`
    );

  // draw distribution selections for linechart
  if (!options.isMap) {
    rows(legendEnter, options, true);
  }

  // draw both base column selections
  rows(legendEnter, options);

  util.wrapText(
    legendEnter.selectAll('text'),
    options.columnWidth - 30,
    options
  );

  util.heightizer(legendEnter, options);

  container.attr(
    'height',
    legend.node().getBBox().height + options.margin.top + options.margin.bottom
  );
}



// WEBPACK FOOTER //
// ../datacenter/app/js/util/d3.legend/d3.legend.js